import { Card, CardContent } from '@/platform-status/components/cards';
import { ErrorClass } from '@/platform-status/entities/platform-component';
import type { TimeBasedPlatformStatus } from '@/platform-status/entities/platform-status';
import { formatDate } from '@/utils/format/date';

import { PlatformComponentStatusBadge } from './platform-component-status-badge';
import { PlatformComponentStatusIcon } from './platform-component-status-icon';

export type PlatformStatusOverallStatusProps = {
  timeBasedPlatformStatus: TimeBasedPlatformStatus;
  updatedAt: Date;
};

export function PlatformStatusOverallStatus({
  timeBasedPlatformStatus,
  updatedAt,
}: PlatformStatusOverallStatusProps) {
  return (
    <Card>
      <CardContent className="grid grid-cols-[min-content_1fr_min-content] items-center gap-4 py-0">
        <div>
          <PlatformComponentStatusIcon
            activeErrorClass={timeBasedPlatformStatus.activeErrorClass}
          />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">
            {timeBasedPlatformStatus.activeErrorClass
              ? titleFromErrorClass[timeBasedPlatformStatus.activeErrorClass]
              : 'All Services Operational'}
          </h2>
          <p className="text-sm text-gray-500">
            Services status as of {formatDate(updatedAt)}
          </p>
        </div>
        <div>
          <PlatformComponentStatusBadge
            activeErrorClass={timeBasedPlatformStatus.activeErrorClass}
          />
        </div>
      </CardContent>
    </Card>
  );
}

const titleFromErrorClass: Record<ErrorClass, string> = {
  [ErrorClass.ERROR_CLASS_2]: 'Some Services are Degraded',
  [ErrorClass.ERROR_CLASS_1]: 'Some Services are Unavailable',
};
